import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { config } from '@/config';
import { WithdrawTable } from '@/components/dashboard/withdraw/withdraw-table';

export default function WithdrawPage(): React.JSX.Element {
  return (
    <>
      <Helmet>
        <title>Quản Lý Rút Tiền | {config.site.name}</title>
      </Helmet>
      <Stack spacing={3}>
        <Stack direction="row" spacing={3}>
          <Stack spacing={1} sx={{ flex: '1 1 auto' }}>
            <Typography variant="h4">Quản Lý Rút Tiền</Typography>
          </Stack>
        </Stack>
        <WithdrawTable/>
      </Stack>
    </>
  );
}
